import { useEffect, useState } from "react";
import { useSupportDocumentationStore } from "@/frontend/store/SupportDocumentationStore";
import { I18n } from "@/i18n/I18n";
import { TablePlaceholder } from "../TablePlaceholder";
import { FileCard } from "../files/FileCard";

/**
 * The customer-facing documentation page. It is read-only for everyone:
 * documentation is managed from Help Content in the admin app.
 */
export function SupportDocumentationTable() {
  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="card-title">{I18n.get('documentation')}</h1>
      </div>
      <SupportDocumentationList canManage={false} />
    </div>
  );
}

export function SupportDocumentationList({ canManage }: { canManage: boolean }) {
  const supportDocumentation = useSupportDocumentationStore(state => state.supportDocumentation);
  const readAllSupportDocumentation = useSupportDocumentationStore(state => state.readAllSupportDocumentation);
  const deleteSupportDocumentation = useSupportDocumentationStore(state => state.deleteSupportDocumentation);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    void readAllSupportDocumentation().finally(() => setLoading(false));
  }, [readAllSupportDocumentation]);

  if(loading) {
    return <table><tbody><TablePlaceholder /></tbody></table>;
  }

  if(supportDocumentation.length === 0) {
    return (
      <div className="empty-list-card-content">
        <p className="list-card-help-text">
          {I18n.get('noDocumentation')}
        </p>
      </div>
    );
  }

  return (
    <div className="mt-4 list-card d-flex flex-column gap-2">
      {supportDocumentation.map(sd => (
        <FileCard
          key={sd.id}
          file={sd.file}
          title={sd.title}
          readOnly={!canManage}
          onDelete={() => deleteSupportDocumentation(sd.id)}
        />
      ))}
    </div>
  );
}
